export function FormatDuration(totalSeconds: number | null | undefined, hideFraction: boolean = false) {
    if (!totalSeconds || totalSeconds <= 0) {
        return "";
    }

    totalSeconds = Math.round(totalSeconds * 10) / 10; // AT-4162 round to the nearest tenth

    const hours = Math.floor(totalSeconds / (3600));
    const minutes = Math.floor((totalSeconds / 60) - (hours * 60));
    const seconds = Math.floor(totalSeconds - (minutes * 60) - (hours * 3600));
    const tenths = Math.round((totalSeconds - (seconds + (minutes * 60) + (hours * 3600))) * 10);
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}${(hideFraction ? "" : `.${tenths}`)}`;
}

export function FormatR2Duration(totalSeconds: number | null | undefined) {
    return FormatDuration(totalSeconds, true);
}

export function FormatTitle(title: string, versionTitle?: string | null | undefined) {
    // append versionTitle (if any) to the title
    return versionTitle ? `${title} - ${versionTitle}` : title;
}

export function FormatTrackNumber(trackNumber: number) {
    return trackNumber === 0 ? "" : trackNumber;
}
